import filterpaper from "../../../img/filterpaper.png";
import "./Projectrightimage.css";

const Projectimage = () => {
  return <img src={filterpaper} className="photossss  reveal fade-right" />;
};

export default Projectimage;
